import { useContext, useState } from 'react'
import ClientContext from 'contexts/ClientContext'
import classNames from 'classnames'
import style from './Card.module.scss'

const Card = ({
  className,
  content,
  disabled,
  inactive,
  titleIcon,
  title,
  cornerContent,
  onClick,
  isCentered,
  warning,
  error,
  hiddenContent
}) => {
  const [ isHover, setIsHover ] = useState(false)
  const { color, colabelNeutralLight, colabelNeutralDark } = useContext(ClientContext)

  return (
    <div
      className={classNames(
        style.card,
        className,
        disabled && style.disabled,
        inactive && style.inactive,
        isCentered && style.centered,
        onClick && style.clickable,
        warning && style.warning,
        error && style.error,
      )}
      onClick={onClick}
      style={color && {
        background: colabelNeutralLight,
        outline: isHover && '1px solid '+color
      }}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {(title || titleIcon || cornerContent) && (
        <div className={style.top}>
          <div className={style.title}>
            {titleIcon}
            <div className={style['title-text']} style={color && {color: colabelNeutralDark}}>{title}</div>
          </div>
          {cornerContent && <div className={classNames(style['corner-content'])} style={color && {color: colabelNeutralDark}}>{cornerContent}</div>}
        </div>
      )}
      {content && <div className={classNames(style['content'], hiddenContent && style.hidden)} style={color && {color: colabelNeutralDark}}>{content}</div>}
    </div>
  )
}

export default Card
